<template>
  <footer class="page-footer green white-text">
    <div class="container" style="bottom: 136px; position: relative; z-index: 99">
      <PictureImg
        src="/images/landing/rasylva-logo-white"
        alt="Rasylva Logo White"
        :extensions="['svg', 'webp', 'png']"
        :img-style="{ width: '120px', display: 'block', marginBottom: '20px' }"
        class="hide-on-large-only"
      />
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-6">
        <div class="flex-1 order-1">
          <a href="/">
            <PictureImg
              src="/images/landing/rasylva-logo-white"
              alt="Rasylva Logo White"
              :extensions="['svg', 'webp', 'png']"
              :img-style="{ width: '120px', display: 'block' }"
              class="hide-on-med-and-down"
            />
          </a>
          <p class="mb-4 font-bold mt-0 text-sm">PT Rasylva Digital Lestari</p>
          <ul class="flex flex-col gap-2 font-medium">
            <li>
              <a
                href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
                target="_blank"
                rel="noreferrer"
                class="white-text flex items-center gap-2"
              >
                <PictureImg
                  src="/images/icons/whatsapp"
                  alt="WhatsApp"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '20px', height: '20px', display: 'block', objectFit: 'contain' }"
                />
                <span>0851-8787-7001</span>
              </a>
            </li>
            <li>
              <a href="mailto:hello@rasylva.id" class="white-text flex items-center gap-2">
                <PictureImg
                  src="/images/icons/email"
                  alt="Email"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '20px', height: '20px', display: 'block', objectFit: 'contain' }"
                />
                <span>hello@rasylva.id</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="flex-1 order-4 lg:order-2">
          <p class="text-lg uppercase font-bold mb-4 mt-0">Menu</p>
          <ul class="flex flex-col gap-2 white-text font-medium">
            <li>
              <a href="/" class="white-text"> Home </a>
            </li>
            <li>
              <a href="/about" class="white-text"> About Us </a>
            </li>
            <li>
              <a href="/#products" class="white-text"> Products </a>
            </li>
            <li>
              <a href="/services/web-app" class="white-text"> Services </a>
            </li>
            <li>
              <a
                href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
                target="_blank"
                rel="noreferrer"
                class="white-text"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
        <div class="flex-1 order-2 lg:order-3">
          <p class="text-lg uppercase font-bold mb-4 mt-0">Links</p>
          <ul class="flex flex-col gap-2 white-text font-medium">
            <li>
              <a href="/terms" class="white-text"> Terms and Conditions </a>
            </li>
            <li>
              <a href="/terms#privacy" class="white-text"> Privacy Policy </a>
            </li>
            <li>
              <a href="/careers" class="white-text"> Careers </a>
            </li>
          </ul>
        </div>
        <div class="flex-1 order-3 lg:order-4">
          <p class="text-lg uppercase font-bold mb-4 mt-0">STAY UPDATED!</p>
          <ul class="flex gap-2 white-text font-medium">
            <li>
              <a
                href="https://instagram.com/rasylva.id"
                target="_blank"
                rel="noreferrer"
                class="white-text flex items-center justify-center w-9 h-9 rounded-full white drop-shadow"
              >
                <PictureImg
                  src="/images/icons/instagram"
                  alt="Instagram"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '18px', height: '18px', display: 'block', objectFit: 'contain' }"
                />
              </a>
            </li>
            <li>
              <a
                href="https://tiktok.com/@rasylva.id"
                target="_blank"
                rel="noreferrer"
                class="white-text flex items-center justify-center w-9 h-9 rounded-full white drop-shadow"
              >
                <PictureImg
                  src="/images/icons/tiktok"
                  alt="TikTok"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '18px', height: '18px', display: 'block', objectFit: 'contain' }"
                />
              </a>
            </li>
            <li>
              <a
                href="https://x.com/rasylva_id"
                target="_blank"
                rel="noreferrer"
                class="white-text flex items-center justify-center w-9 h-9 rounded-full white drop-shadow"
              >
                <PictureImg
                  src="/images/icons/x"
                  alt="X"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '18px', height: '18px', display: 'block', objectFit: 'contain' }"
                />
              </a>
            </li>
            <li>
              <a
                href="https://youtube.com/@rasylva_id"
                target="_blank"
                rel="noreferrer"
                class="white-text flex items-center justify-center w-9 h-9 rounded-full white drop-shadow"
              >
                <PictureImg
                  src="/images/icons/youtube"
                  alt="Youtube"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '18px', height: '18px', display: 'block', objectFit: 'contain' }"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-copyright" style="position: absolute; overflow: inherit; bottom: 0; width: 100%">
      <PictureImg src="/images/landing/feline-green" alt="Feline" :extensions="['svg']" img-class="feline" />
      <div class="container center" style="z-index: 1">
        <span class="font-medium">© 2019-{{ currentYear }} Rasylva.id. All rights reserved.</span>
      </div>
    </div>
  </footer>
</template>

<script>
import PictureImg from '~/components/picture-img';
import datetimeMixin from '~/mixins/datetime';

export default {
  components: {
    PictureImg,
  },
  mixins: [datetimeMixin],
};
</script>

<style lang="scss" scoped>
.page-footer {
  position: relative;
  height: auto;
  padding-top: 180px;
  @media only screen and (min-width: 993px) {
    padding-top: 180px;
    height: auto;
  }
  .right-align {
    @media only screen and (min-width: 993px) {
      text-align: right;
    }
  }
}

::v-deep .feline {
  height: 150px;
  bottom: 2px;
  right: 50%;
  position: absolute;
  transform: translate(40%) scaleX(-1);
  @media only screen and (min-width: 993px) {
    height: 150px;
    bottom: 2px;
    right: 16%;
    transform: none;
  }
}
</style>
